export default (table) => {
  let name = 'promotion_job_grade';
  let visible_in_tooltip = /* Release 3.2 - 1.1 - Starts */(column, data, account) =>    
  ((data.request_type === "businessexcellenceaward" || data.request_type === "onetime") || (data.request && (data.request.request_type === "businessexcellenceaward" || data.request.request_type === "onetime"))) ? false : true;
  /* Release 3.2 - 1.1 - Ends */
  let defaultValue = (value, data) => data.job_grade;

  switch (table) {
    case 'editCompensation':
    case 'rejectRequests':
    case 'approveRequests':
      case 'editInternalHire':
      name = 'request.promotion_job_grade';
      defaultValue = (value, data) => data.request.for.job_grade;
      break;
    case 'myRequests':
    case 'approvedRequestHistory':
    case 'requestsHistory':
    case 'pendingRequests':
      defaultValue = (value, data) => data.for.job_grade;
      break;
    default:
      break;
  }

  return { 
    name,
    label: "Job Grade",
    tooltip_section: "New",
    visible_in_tooltip,
    defaultValue
  };
};